import { Parent } from './../../shared/class/parent.model';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { User } from '../../shared/class/user.model';
import { AuthService } from '../../services/auth.service'
import pageSettings from '../../config/page-settings';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-login-convocatoria',
  templateUrl: './login-convocatoria.component.html',
  styleUrls: ['./login-convocatoria.component.scss'],
  providers: [AuthService]
})
export class LoginConvocatoriaComponent extends Parent implements OnInit {

  pageSettings = pageSettings;
  public formGroup: FormGroup;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
    private router: Router
  ) {
    super();
    //this.pageSettings.pageEmpty = true;
    this.renderer.addClass(document.body, 'bg-white');
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      email: [null, Validators.required],
      password: [null, Validators.required]
    });
  }

  onLogin(user: User) {
    this.router.navigate(['/registro']);
  }
}
